<template>
  <div class="response-confirmed-column">
    {{confirmedResponseLabel}}
  </div>
</template>

<script setup lang="ts">

import {computed, toRefs} from "vue";

  const props = withDefaults(defineProps<{
    row: any,
    value?: number | string | null,
  }>(), {
    value: 0,
  });
  const {
    row,
    value,
  } = toRefs(props);

  const emit = defineEmits<{
    'click': [any],
  }>();

  const confirmedResponseLabel = computed(() => {
    switch (Number(value.value ?? 0)) {
      case 0:
        return 'Unconfirmed';
      case 1:
        return 'Yes';
      case 2:
        return 'No';
      case 3:
        return 'Unsure';
    }
  })

</script>

<style scoped lang="scss">
    .response-confirmed-column {
      max-width: 200px;
    }
</style>